import React, { PropsWithChildren } from "react";
import classNames from "classnames";

type CardProps = PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>;

export const Card = ({ children, className, ...props }: CardProps) => {
  return (
    <div
      className={classNames(
        "border border-[#E4E4E4] rounded-[15px] p-8 text-sm",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export const LightPurpleCard = ({
  children,
  className,
  ...props
}: CardProps) => {
  return (
    <div
      className={classNames(
        "rounded-[15px] p-8 text-sm bg-[#F0EFFA]",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
